import {Injectable} from '@angular/core';
import * as formatcoords from 'formatcoords';

@Injectable({
  providedIn: 'root'
})

export class CoordinatesService {
  format(lat: number, lng: number): string {
    return formatcoords(lat, lng).format('DD mm X', {decimalPlaces: 3, latLonSeparator: ', '});
  }
}
